import {documentsService} from "@/_services";
import router from "@/router";

export default {
  getDocument({dispatch, commit}, {uuid}) {
    dispatch('alert/clear', {}, { root: true });
    return documentsService.getDocument(uuid)
      .then(
        document => {
          commit("setDocumentsData", document.data[0])
          return Promise.resolve(document.data[0])
        },
        error => {
          dispatch("alert/error", error, {root:true});
          router.push("/");
          return Promise.reject();
        }
      )
  },
  flushDocument({commit}) {
    commit("setDocumentsData", [])
  }
}
